<template>
	<div>
		<div class="colhead">
			<h2 class="header_h2">权限信息管理</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="权限名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>
		
		</el-header>
		<el-main>
			
			<el-table border ref="multipleTable" tooltip-effect="dark" :data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">

				<el-table-column prop="permissionid" label="权限编号" width="120px"></el-table-column>
				<el-table-column prop="fid" label="父编号" width="120px"></el-table-column>

				<el-table-column prop="showname" label="名称" width="100px"></el-table-column>
				<el-table-column prop="routeurl" label="页面地址" width="220px"></el-table-column>
				<el-table-column prop="showlevel" label="级数" width="100px"></el-table-column>
				<el-table-column prop="ordernum" label="排序" width="100px"></el-table-column>
				<el-table-column label="操作" width="150px">
					<template slot-scope="scope">
						<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>
					<el-button type="text" @click="handleDelete(scope.$index, scope.row)" icon="el-icon-circle-close" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>
		<!-- 修改个人信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo">
				<el-form-item label="权限编号">
					<el-input style="display:inline-block;width:80%;" v-model="EditInfo.permissionid" placeholder="请输入权限编号"></el-input>
				</el-form-item>
				<el-form-item label="父编号">
					<el-input style="display:inline-block;width:80%;" v-model="EditInfo.fid" placeholder="请输入父编号"></el-input>
				</el-form-item>
				<el-form-item label="权限名称">
					<el-input style="display:inline-block;width:80%;" v-model="EditInfo.showname" placeholder="请输入权限名称"></el-input>
				</el-form-item>
				<el-form-item label="页面地址">
					<el-input style="display:inline-block;width:80%;" v-model="EditInfo.routeurl" placeholder="请输入页面地址"></el-input>
				</el-form-item>
				<el-form-item label="">
					<li>级数:<el-input type='number' style="display:inline-block;width: 100px;" v-model="EditInfo.showlevel"></el-input>
					</li>
					<li>排序:<el-input type='number' style="display:inline-block;width: 100px;" v-model="EditInfo.ordernum"></el-input>
					</li>
				</el-form-item>
			</el-form>
			<!-- 按钮确定和取消 -->
			<span slot="footer">
				<el-button type="primary" @click.native="bao1editSure">确定</el-button>
				<el-button @click.native="bao1edit = false">取消</el-button>
			</span>
		</el-dialog>

		<!-- ----新增个人信息---- -->
		<el-dialog title="新增用户信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo">
				<el-form-item label="权限编号">
					<el-input style="display:inline-block;width:80%;" v-model="AddInfo.permissionid" placeholder="请输入权限编号"></el-input>
				</el-form-item>
				<el-form-item label="父编号">
					<el-input style="display:inline-block;width:80%;" v-model="AddInfo.fid" placeholder="请输入父编号"></el-input>
				</el-form-item>
				<el-form-item label="权限名称">
					<el-input style="display:inline-block;width:80%;" v-model="AddInfo.showname" placeholder="请输入权限名称"></el-input>
				</el-form-item>
				<el-form-item label="页面地址">
					<el-input style="display:inline-block;width:80%;" v-model="AddInfo.routeurl" placeholder="请输入页面地址"></el-input>
				</el-form-item>
				<el-form-item label="">
					<li>级数:<el-input type='number' style="display:inline-block;width: 100px;" v-model="AddInfo.showlevel"></el-input>
					</li>
					<li>排序:<el-input type='number' style="display:inline-block;width: 100px;" v-model="AddInfo.ordernum"></el-input>
					</li>
				</el-form-item>
			</el-form>
			<!-- 按钮确定和取消 -->
			<span slot="footer">
				<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
				<el-button @click.native="bao1newadd = false">取消</el-button>
			</span>
		</el-dialog>
	</div>
</template>



<script>
	import permission from '../apifunction/Permission.js'
	import commfun from '../commontools/CommonFun.js'
	export default {
		data() {
			return {
				permissionlist: [],
				currentPage: 1,
				pagesize: 10,
				bao1edit: false,
				bao1newadd: false,
				editchk: true,
				addchk: true,
				idx: null,
				//   通过姓名查询
				select_word: "",
				//   定义初始个人信息
				EditInfo: {
					permissionid: '',
					fid: '',
					showname: '',
					showlevel: 0,
					routeurl: '',
					ordernum: 0
				},
				AddInfo: {
					permissionid: '',
					fid: '',
					showname: '',
					showlevel: 0,
					routeurl: '',
					ordernum: 0
				}
			};
		},
		mounted() {
			this.GetAllPermission();
		},
		methods: {
			//   得到所有的数据---------------
			GetAllPermission() {
				permission.GetAllPermission()
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data));

						if (ent.Flag == 'success') {
							this.permissionlist = JSON.parse(ent.Data);

						}
					})
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			handleDelete(index, row) {
				this.$confirm('确定要删掉此信息?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(res => {
					permission.DelPermission(row.permissionid)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								this.permissionlist.splice(index,1)
								this.bao1detele = false;
								this.$message.warning("删除成功");
			
							} else {
								this.$message.info(ent.Msg);
							}
						})
			
					// this.$message({
					//   type: 'success',
					//   message: '删除成功!'
					// });
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;
				this.EditInfo = {
					permissionid: row.permissionid,
					fid: row.fid,
					showname: row.showname,
					showlevel: row.showlevel,
					routeurl: row.routeurl,
					ordernum: row.ordernum
				};
				this.editchk = row.isvalid == "1" ? true : false;
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				this.EditInfo.isvalid = this.editchk ? "1" : "0";
				permission.EditPermission(this.EditInfo)
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.data.splice(this.idx, 1, this.EditInfo)
							//this.$set(this.data, this.idx, this.EditInfo);
							this.bao1edit = false;
							this.$message.success("修改成功");
						} else
							this.$message.success(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.addchk = true;
				this.AddInfo.permissionid = "";
				this.AddInfo.fid = "";
				this.AddInfo.showname = "";
				this.AddInfo.showlevel = 0;
				this.AddInfo.routeurl = "";
				this.AddInfo.ordernum = 0;
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				if (this.AddInfo.showname == '' || this.AddInfo.permissionid == '') {
					this.$message.info("权限编号和名称不能为空！");
					return;
				}
				permission.AddPermission(this.AddInfo)
					.then(res1 => {
						var ent1 = JSON.parse(JSON.stringify(res1.data))
						if (ent1.Flag == 'success') {
							//this.AddInfo.id = ent1.data;
							// if(this.data.length>=this.currentPage*this.pagesize)
							// this.data.pop();
							this.data.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.currentPage = 1;
							this.$message.success("新增成功");
						} else
							this.$message.info(ent1.Msg);
					})
			}
		},
		computed: {
			data() {
				return this.permissionlist.filter(item => {
					if (this.select_word == '')
						return item;
					else if (item.showname.indexOf(this.select_word) > -1) {
						return item;
					}

				});
			}
		}
	};
</script>


<style scoped>
	.colhead {
		padding-bottom: 2px;
		border-bottom: 1px solid #ccc;
		width: 100%;
	}
</style>
